function staff_Reducer(state = [], action) {
    switch (action.type) {
        case 'STAFF/SET':            
            return action.staff;
        case 'STAFF/CLEAR':
            return null;
        default:
            return state;
    }
}

export default staff_Reducer;
